import { OptionsIcon } from "assets/icons/OptionsIcon";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { ModalConfirm } from "components/ModalConfirm/ModalConfirm";
import { NivelI } from "interfaces/Nivel";
import { Dropdown } from "react-bootstrap";
import { deleteNiveles } from "services/niveles";

interface Props {
  elemento: NivelI;
  onClickEdit: (elemento: NivelI) => void;
  refreshTable: () => void;
}

export const NivelRowActions = ({
  elemento,
  onClickEdit,
  refreshTable,
}: Props) => {
  const handleDelete = async (id: string | number) => {
    try {
      await deleteNiveles(id);
      showSuccessToast("¡El nivel fue eliminado con éxito!");
      refreshTable();
    } catch (error:any) {
      showErrorToast("Error eliminando el nivel: ", error.message);
    }
  };

  // const onClickVerDocumento = (id: string | number) => {
  //     openFile({ id })
  // }

  return (
    <Dropdown className="acciones-dropdown | d-flex justify-content-center">
      <Dropdown.Toggle>
        <OptionsIcon />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={() => onClickEdit(elemento)}>
          Editar
        </Dropdown.Item>

        <ModalConfirm
          title="Eliminar nivel"
          onConfirm={() => handleDelete(elemento.id)}
          message={
            <p>
              Estas por eliminar el Nivel {elemento.nombre} <br />
              <b>¿Querés realizar esta acción? Esta acción es irreversible.</b>
            </p>
          }
          renderButton={(handleShow: () => void) => (
            <Dropdown.Item onClick={handleShow}>Eliminar</Dropdown.Item>
          )}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};
